/**
 * Split a composite relationship key into base key and order suffix.
 *
 * Relationship keys are expected as: <base>_FIRST or <base>_SECOND. If no underscore is found,
 * returns the original value as `relKey` with an empty `order`.
 *
 * @param {string} relKey Composite relationship key (e.g. 'PARENT_CHILD_FIRST').
 * @returns {{ relKey: string, order: string }} Parsed key parts.
 */
export function parseRelKey(relKey) {
  const lastUnderscoreIndex = relKey?.lastIndexOf('_')
  const relKeyPart = lastUnderscoreIndex !== -1 ? relKey?.substring(0, lastUnderscoreIndex) : relKey
  const order = lastUnderscoreIndex !== -1 ? relKey?.substring(lastUnderscoreIndex + 1) : ''
  return { relKey: relKeyPart, order }
}

/**
 * Prepares person IDs and partition keys based on relationship direction.
 * When relationshipDirection is FIRST, the otherPerson is person1 and the main person is person2.
 * Otherwise, the main person is person1 and otherPerson is person2.
 *
 * @param {Object} params
 * @param {Object} params.person - Primary person object
 * @param {Object} params.otherPerson - Related person object
 * @param {string} params.relationshipDirection - Relationship direction ('FIRST' or 'SECOND')
 * @returns {{ person1Id: string, person2Id: string, person1PartitionKey: string, person2PartitionKey: string }}
 *   Ends of the relationship, ordered
 */
export function preparePersonIdsAndPartitionKeys({ person, otherPerson, relationshipDirection }) {
  let person1Id = person.id
  let person2Id = otherPerson.id
  let person1PartitionKey = person.partitionKey
  let person2PartitionKey = otherPerson.partitionKey

  if (relationshipDirection === 'FIRST') {
    person1Id = otherPerson.id
    person2Id = person.id
    person1PartitionKey = otherPerson.partitionKey
    person2PartitionKey = person.partitionKey
  }

  return { person1Id, person2Id, person1PartitionKey, person2PartitionKey }
}
